// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts {
  width: 90%;
  margin: auto;
  padding: 0;
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.contacts__wrapper {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding-bottom: 60px;
}

.contacts__block {
  width: 500px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contacts__photo {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 60px 0 40px;
}

.contacts__phone {
  width: 80%;
  font-family: Oswald-light, sans-serif;
  font-weight: 300;
  font-size: 0.9em;
  color: #073042;
  text-decoration: none;
  margin: 0;
  margin-bottom: 37px;
}

.contacts__text {
  font-family: ShantellSans-Italic, sans-serif;
  font-size: 1em;
  line-height: 26px;
  color: #023952;
  font-weight: 400;
  text-align: center;
  margin: 0;
  padding: 30px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.contacts__btn {
  width: 80%;
  height: 65px;
  margin: 0;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 400;
  text-align: center;
  padding: 16px;
  text-decoration: none;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contacts__btn-telegram {
  border-color: #0087d0;
  border-style: ridge;
  color: #0087d0;
  margin: 40px 0;
}

.contacts__btn-whatsapp {
  border-color: #27d061;
  border-style: ridge;
  color: #27d061;
}

.contacts__btn:hover {
  color: #082c15;
}

@media screen and (max-width: 610px) {
  .contacts__block {
    max-width: 280px;
  }

  .contacts__photo {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin: 30px 0;
  }

  .contacts__btn {
    height: 45px;
  }

  .contacts__btn-telegram {
    margin: 20px 0;
  }

  .contacts__line {
    margin: 18px auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contacts/Contacts.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".contacts {\r\n  width: 90%;\r\n  margin: auto;\r\n  padding: 0;\r\n  flex-grow: 1;\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.contacts__wrapper {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n  padding-bottom: 60px;\r\n}\r\n\r\n.contacts__block {\r\n  width: 500px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.contacts__photo {\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 50%;\r\n  margin: 60px 0 40px;\r\n}\r\n\r\n.contacts__phone {\r\n  width: 80%;\r\n  font-family: Oswald-light, sans-serif;\r\n  font-weight: 300;\r\n  font-size: 0.9em;\r\n  color: #073042;\r\n  text-decoration: none;\r\n  margin: 0;\r\n  margin-bottom: 37px;\r\n}\r\n\r\n.contacts__text {\r\n  font-family: ShantellSans-Italic, sans-serif;\r\n  font-size: 1em;\r\n  line-height: 26px;\r\n  color: #023952;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  margin: 0;\r\n  padding: 30px 0;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.contacts__btn {\r\n  width: 80%;\r\n  height: 65px;\r\n  margin: 0;\r\n  font-family: \"Open Sans\", Arial, sans-serif;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  padding: 16px;\r\n  text-decoration: none;\r\n  border-radius: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.contacts__btn-telegram {\r\n  border-color: #0087d0;\r\n  border-style: ridge;\r\n  color: #0087d0;\r\n  margin: 40px 0;\r\n}\r\n\r\n.contacts__btn-whatsapp {\r\n  border-color: #27d061;\r\n  border-style: ridge;\r\n  color: #27d061;\r\n}\r\n\r\n.contacts__btn:hover {\r\n  color: #082c15;\r\n}\r\n\r\n@media screen and (max-width: 610px) {\r\n  .contacts__block {\r\n    max-width: 280px;\r\n  }\r\n\r\n  .contacts__photo {\r\n    width: 120px;\r\n    height: 120px;\r\n    border-radius: 50%;\r\n    margin: 30px 0;\r\n  }\r\n\r\n  .contacts__btn {\r\n    height: 45px;\r\n  }\r\n\r\n  .contacts__btn-telegram {\r\n    margin: 20px 0;\r\n  }\r\n\r\n  .contacts__line {\r\n    margin: 18px auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
